import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ContactService } from '../../services/contact.service';
import { Email } from '../../models/models';

@Component({
    selector: 'contact-email-popup',
    templateUrl: './contact-email-popup.component.html',
    standalone: false
})
export class ContactEmailPopup implements OnInit {
    // Carrier, Customer, Dispatcher
    @Input() contactType: string = "";
    @Input() tableID: number = 0;
    @Input() selectedContacts: Email[] = [];
    @Input() contacts: Email[] = [];
    @Input() typedEmails: string = "";
    @Output() contactsChanged: EventEmitter<Email[]> = new EventEmitter<Email[]>();
    @Output() emailsChanged: EventEmitter<string> = new EventEmitter<string>();

    //public contacts: Email[] = [];
    public emails: string[] = [];
    //public selectedContacts: Email[] = [];
    public selectedEmails: string = "";

    constructor(public contactService: ContactService) {
    }

    ngOnInit() {
        //this.getContacts();
    }

    getContacts() {
        //this.contactService.getContactsByTableIdType(this.tableID, this.contactType).subscribe(result => {
        //    var contacts = result;
        //    for (var i = 0; i < contacts.length; i++) {
        //        if (contacts[i].email != null && contacts[i].email != "") {
        //            this.contacts.push({
        //                email: contacts[i].email,
        //                name: contacts[i].fullName
        //            });
        //        }
        //        if (contacts[i].defaultContactInd == true) {
        //            this.defaultEmail = contacts[i].email;
        //            this.defaultName = contacts[i].fullName;
        //        }
        //    }
        //    if (this.initContacts && this.initContacts.length > 0) {
        //        this.selectedContacts = this.initContacts;
        //    }
        //    console.log("getContacts", this.selectedEmails, this.selectedContacts);
        //});
    }

    selectionChanged() {
        this.contactsChanged.emit(this.selectedContacts);
    }

    emailsOnChange(emails: string) {
        this.selectedEmails = emails;
        //console.log("emailsOnChange", this.contacts, this.selectedEmails, this.selectedContacts, this.typedEmails, this.defaultContact);
        this.emailsChanged.emit(this.selectedEmails);
    }
}

@Component({
    selector: 'contact-multiselect-dialog',
    templateUrl: './dialog.component.html',
    standalone: false
})
export class ContactMultiselectDialog {
    public defaultContact: Email = {} as Email;
    public selectedContacts: Email[] = [];
    public typedEmails: string = "";
    public notes: string = '';

    constructor(public dialogRef: MatDialogRef<ContactMultiselectDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.selectedContacts = data.selectedContacts;
        this.typedEmails = data.typedEmails;
        this.defaultContact = data.defaultContact;
    }

    contactSelected(contacts: Email[]) {
        this.selectedContacts = contacts;
        //console.log("contactSelected", this.selectedContacts, this.typedEmails);
    }

    emailsSelected(emails: string) {
        this.typedEmails = emails;
        //console.log("emailsSelected", this.selectedContacts, this.typedEmails);
    }
    
    select(): void {
        //console.log("select", this.selectedContacts, this.typedEmails, this.notes);
        this.dialogRef.close({ selectedContacts: this.selectedContacts, typedEmails: this.typedEmails, notes: this.notes, btnOK: true });
    }

    cancel(): void {
        this.dialogRef.close({ selectedContacts: null, typedEmails: null, notes: null, btnOK: false });
    }
}